import toast from "react-hot-toast";
import { filesAPI } from "../service/apiUrl";

export const conditionalProp = (condition, propObj) =>
  condition ? propObj : {};

export const combineClasses = (...classes) => {
  return classes.join(" ");
};

export const getAccessToken = () => {
  return localStorage.getItem("accessToken");
};

export const setAccessToken = (token) => {
  return localStorage.setItem("accessToken", token);
};

export const setUserLoginMailId = (userId) => {
  return localStorage.setItem("userId", userId);
};

export const getUserLoginMailId = () => {
  return localStorage.getItem("userId");
};

export const getRefreshToken = () => {
  return localStorage.getItem("accessToken");
};

export const setRefreshToken = (token) => {
  return localStorage.setItem("refreshToken", token);
};

export const removeTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

export const setShowNotifier = (value) => {
  return localStorage.setItem("displayNotifier", value);
}

export const getShowNotifier = () => {
  return localStorage.getItem("displayNotifier");
}

export const onlyNumbersInput = (e) => {
  ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
};

export const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};

export const serverFiles = (url) => {
  if (!url) return null;
  return `${filesAPI}${url.startsWith("/") ? "" : "/"}${url}`;
};
// export const debounce = (func, delay = 300) => {
//   let timerId;
//   return (...args) => {
//   if(timerId) clearTimeout(timerId);
//     timerId = setTimeout(() => {
//       func(...args);
//     }, delay);
//   };
// };

export function getTimeAgo(dateString) {
  const now = new Date();
  const createdAt = new Date(dateString);
  const seconds = Math.floor((now.getTime() - createdAt.getTime()) / 1000);

  if (seconds < 60) return "Just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  return `${days}d`;
}
export const checkNotAdmin = () =>
  process.env.REACT_APP_ROUTES_PATH === "./routes";

export const selectMapper = (arr, valueKey = "id", labelKey = "name") => {
  const result = arr?.map((item) => {
    return {
      value: item[valueKey],
      label: item[labelKey],
    };
  });
  return result;
};

export const formatNumberShort = (value) => {
  if (value >= 1000000)
    return (value / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  if (value >= 1000) return (value / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  return value.toString();
};

export const capitalizeFirstChar = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const experienceOptions = [
  { label: "0", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "10+", value: "10+" },
];

export const newPostTags = [
  { label: "Network", value: "0" },
  { label: "Ideas", value: "1" },
  { label: "Collaboration", value: "2" },
  { label: "Following", value: "3" },
  { label: "Testing", value: "4" },
];

export const handleCopy = (text, success) => {
  if (!text) {
    toast.error("Nothing to copy");
    return;
  }

  // Try Clipboard API first
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard
      .writeText(text)
      .then(() => toast.success(success || "Copied"))
      .catch((err) => {
        console.error("Clipboard API failed:", err);
        fallbackCopy(text);
      });
  } else {
    // Use fallback for mobile or insecure context
    fallbackCopy(text);
  }
};

// Fallback using a temporary textarea
export const fallbackCopy = (text, success, error) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.position = "fixed";
  textArea.style.top = 0;
  textArea.style.left = 0;
  textArea.style.width = "2em";
  textArea.style.height = "2em";
  textArea.style.padding = 0;
  textArea.style.border = "none";
  textArea.style.outline = "none";
  textArea.style.boxShadow = "none";
  textArea.style.background = "transparent";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    if (successful) {
      toast.success(success || "Copied");
    } else {
      toast.error("Failed to copy");
    }
  } catch (err) {
    console.error("Fallback copy failed:", err);
    toast.error(error || "Copy not supported");
  }

  document.body.removeChild(textArea);
};

//Project duration
export const convertDurationToDays = (durationStr) => {
  if (!durationStr) return 0;
  const [countStr, unitRaw] = durationStr.trim().toLowerCase().split(" ");
  const count = parseInt(countStr);
  const unit = unitRaw?.toLowerCase();
  if (isNaN(count)) return 0;
  switch (unit) {
    case "day":
    case "days":
      return count;
    case "month":
    case "months":
      return count * 30;
    case "year":
    case "years":
      return count * 365;
    default:
      return 0;
  }
};
export const convertDaysToReadableDuration = (days) => {
  if (typeof days !== "number" || isNaN(days) || null) return "";

  if (days % 365 === 0) {
    const years = days / 365;
    return `${years} year${years > 1 ? "s" : ""}`;
  }
  if (days % 30 === 0) {
    const months = days / 30;
    return `${months} month${months > 1 ? "s" : ""}`;
  }
  return `${days} day${days > 1 ? "s" : ""}`;
};

export function convertToISOStringFromYMD(dateStr) {
  if (!dateStr) return "";

  const [year, month, day] = dateStr.split("-");

  const now = new Date();

  const date = new Date(
    Date.UTC(
      parseInt(year),
      parseInt(month) - 1,
      parseInt(day),
      now.getHours(),
      now.getMinutes(),
      now.getSeconds(),
      now.getMilliseconds()
    )
  );

  return date.toISOString();
}

export function convertISOToYMD(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toISOString().split("T")[0]; // "YYYY-MM-DD"
}
export const accountStatusOptions = [
  { label: "Active", value: "ACTIVE" },
  { label: "Cancelled", value: "CANCELLED" },
  { label: "Expired", value: "EXPIRED" },
  { label: "Queued", value: "QUEUED" },
];
export const compressImage = async (file, { quality = 0.50 } = {}) => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) {
      return resolve(file);
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const width = img.width;
        const height = img.height;

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              return resolve(file); // Fallback to original if blob creation fails
            }
            const compressedFile = new File([blob], file.name, {
              type: "image/jpeg",
              lastModified: Date.now(),
            });

            // console.group("Image Compression");
            // console.log("Original Size:", (file.size / 1024).toFixed(2), "KB");
            // console.log("Compressed Size:", (compressedFile.size / 1024).toFixed(2), "KB");
            // console.log("Quality:", quality);
            // console.groupEnd();

            resolve(compressedFile);
          },
          "image/jpeg",
          quality
        );
      };
      img.onerror = (err) => reject(err);
    };
    reader.onerror = (err) => reject(err);
  });
};
